module.exports = __webpack_public_path__ + "img/iriomote_5.374d8149.jpg";